import { render, staticRenderFns } from "./SpaceInformation.vue?vue&type=template&id=1ec27dd9&scoped=true&"
import script from "./SpaceInformation.vue?vue&type=script&lang=js&"
export * from "./SpaceInformation.vue?vue&type=script&lang=js&"
import style0 from "./SpaceInformation.vue?vue&type=style&index=0&id=1ec27dd9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec27dd9",
  null
  
)

export default component.exports